<template>
    
    <div v-if="!$apollo.loading">

        <div class="text-xs">
            
            <ul class="w-full flex justify-around mb-0 list-none flex-wrap pt-1 pb-2 flex-row mt-10">
                
                <li v-if="sessionsLength > 0" 
                class="-mb -px ms-1 me-2 last:mr-0 flex-auto text-center">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(1)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 1, 'text-white bg-blue-600': openedTab === 1}">
                    
                        {{$t(`menu.sessions`)}}
                    </a>
                </li>

                <li v-if="pitchesLength > 0" 
                class="-mb-px me-2 last:mr-0 flex-auto text-center">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(2)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 2, 'text-white bg-blue-600': openedTab === 2}">
                        
                        {{$t(`menu.pitches`)}}

                    <!-- {{$t('menu.map')}} -->
                    </a>
                </li>

                <li v-if="gymMembershipsLength > 0 || studioMembershipsLength > 0 
                    || maMembershipsLength > 0 || classMembershipsLength > 0" 
                class="-mb-px me-2 last:mr-0 flex-auto text-center">
                    <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="callItemIsSelected(3)" v-bind:class="{'text-pink-600 bg-white': openedTab !== 3, 'text-white bg-blue-600': openedTab === 3}">
                        
                        {{$t(`menu.memberships`)}}
                    </a>
                </li>
            </ul>
        </div>

        <div>

            <div v-if="openedTab == 1">

                <sessions :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>                
            </div>

            <div v-if="openedTab == 2">
                
                <booking-pitches :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>                
            </div>

            <div v-if="openedTab == 3">

                <div class="text-xs">
            
                    <ul class="w-full flex justify-around mb-0 list-none flex-wrap pt-1 pb-2 flex-row">
                        
                        <li v-if="gymMembershipsLength > 0" 
                            
                        class="-mb -px ms-1 me-2 last:mr-0 flex-auto text-center">
                            <a class="text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal" v-on:click="callMembershipItemIsSelected(1)" v-bind:class="{'text-pink-600 bg-white': membershipsOpenedTab !== 1, 'text-white bg-blue-600': membershipsOpenedTab === 1}">
                            
                                {{$t(`menu.gyms`)}}
                            </a>
                        </li>

                        <li v-if="studioMembershipsLength > 0" 
                        class="-mb-px me-2 last:mr-0 flex-auto text-center">
                            <a class="text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal" v-on:click="callMembershipItemIsSelected(2)" v-bind:class="{'text-pink-600 bg-white': membershipsOpenedTab !== 2, 'text-white bg-blue-600': membershipsOpenedTab === 2}">
                                
                                {{$t(`menu.studios`)}}

                            <!-- {{$t('menu.map')}} -->
                            </a>
                        </li>

                        <li v-if="maMembershipsLength > 0" 
                        class="-mb-px me-2 last:mr-0 flex-auto text-center">
                        
                            <a class="text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal" v-on:click="callMembershipItemIsSelected(3)" v-bind:class="{'text-pink-600 bg-white': membershipsOpenedTab !== 3, 'text-white bg-blue-600': membershipsOpenedTab === 3}">
                                
                                {{$t(`menu.ma`)}}

                            <!-- {{$t('menu.map')}} -->
                            </a>
                        </li>

                        <li v-if=" classMembershipsLength > 0" 
                        class="-mb-px me-2 last:mr-0 flex-auto text-center">
                            <a class="text-xs font-bold uppercase px-2 py-3 shadow-lg rounded block leading-normal" v-on:click="callMembershipItemIsSelected(4)" v-bind:class="{'text-pink-600 bg-white': membershipsOpenedTab !== 4, 'text-white bg-blue-600': membershipsOpenedTab === 4}">
                                
                                {{$t(`menu.classes`)}}
                            </a>
                        </li>
                    </ul>
                </div>

                <div v-if="membershipsOpenedTab == 1">

                    <gyms-memberships :user="user" :category="category" :county="county" :location="location" 
                    :myReload="myReload" :tokenId="tokenId"
                    :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>
                </div>

                <div v-if="membershipsOpenedTab == 2">

                    <studios-memberships :user="user" :category="category" :county="county" :location="location" 
                    :myReload="myReload" :tokenId="tokenId"
                    :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>
                </div>

                 <div v-if="membershipsOpenedTab == 3">

                    <ma-memberships :user="user" :category="category" :county="county" :location="location" 
                    :myReload="myReload" :tokenId="tokenId" 
                    :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>
                </div>

                <div v-if="membershipsOpenedTab == 4">

                    <classes-memberships :user="user" :category="category" :county="county" :location="location" 
                    :myReload="myReload" :tokenId="tokenId"
                    :myBusinessId="myBusinessId" :hideSessionsTitle="true" :isFromBusinessBrowse="true"/>
                </div>
            </div>
        </div>

        <div v-if="!isIos()" class="mt-20">
        </div>
    </div>

    <div v-else class="myCenter mt-20">

    </div>
</template>


<script>


import { RingLoader } from 'vue-spinners-css';

import myQueries from '../../hasura/myQueries';

import myInserts from '../../hasura/myInserts';

import mySubscriptions from '../../hasura/mySubscriptions';

import customerQueries from '../../hasura/CustomerQueries';

import customerSubscriptions from '../../hasura/CustomerSubscriptions';

import myThreeQueries from '../../hasura/myThreeQueries';

import componentsHelpers from '../../classes/componentHelpers';

import sessions from '../../views-v2/Sessions'

import bookingPitches from '../../views-v2/BookingPitches'

import gymsMemberships from '../../views-v2/GymsMemberships'
import studioMemberships from '../../views-v2/StudioMemberships'
import maMemberships from '../../views-v2/MaMemberships'
import classesMemberships from '../../views-v2/ClassesMemberships'

export default {

    mounted(){

        // console.log(`in fitness tabs`)
        // this.itemIsSelected(1);
    },

    components:{

        sessions,
        bookingPitches,
        gymsMemberships,
        studioMemberships,
        maMemberships,
        classesMemberships
    },

    props:{

       
        myBusinessId: 0,
        
        isFromPage: false,

        // itemIsSelected: {

        //     type: Function
        // },
    },

    methods:{

        isIos(){

        // alert(`isIos: ${componentsHelpers.isIos()}`)
            return componentsHelpers.isIos();
        },

        callItemIsSelected(value){

            // console.log(`value: ${value}`);

            this.openedTab = value

            // this.itemIsSelected(value);
        },

        callMembershipItemIsSelected(value){

            this.membershipsOpenedTab  = value;
        },

         myReload(){

            location.reload();
        },
    },

    apollo: {

        withUser:{

            query: myQueries.token_and_user_query,

            update(data){

                try{

                    this.tokenId = data.token[0].id;

                    if(typeof data.token[0].user != 'undefined' && data.token[0].user!= null){

                            this.user = data.token[0].user;

                            this.userId = this.user.id;
                            
                        }
                        else{

                            componentsHelpers.toastIt(this.$t('sessions.completeYourProfile'),  2, 'outline', true);

                            this.disablePage = true;
                        }
                    }catch(error){

                    componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessFintessTabs', 'apollo', 'withUser query - 1', error);

                    componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                }
            },

            error(error){
                
                componentsHelpers.sendError(this.$apollo, 0,'MyPages-BusinessFintessTabs', 'apollo', 'withUser query - 2', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            }
        },

        category: {

          query: myQueries.category_query,



          error(error){
              
            if(this.categoryMutationError == '' ){

              componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessFintessTabs', 'Apollo', 'category', error);

              componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
              
              this.categoryMutationError = JSON.stringify(error);
            }
            },
        },

      county: {

        query: myQueries.counties_queries,

        variables:{

          countryName: 'Kuwait'
        },

        update(data){

        //   this.city =  data.location_country;
            
          this.county =  data.location_country_county;
          // console.log(`city: ${JSON.stringify(this.county)}`)

          // this.countiesOptions = this.county.filter(item=>item);

          return data.location_country_county;
        },

        error(error){
          
          if(this.countiesError == ''){

            componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessFintessTabs', 'apollo', 'city', error);

            componentsHelpers.toastIt(this.$toasted, 'An error happened, and sent to admin', 3, 'outline', true);

              this.countiesError = error;
          }
        },
    },

      location: {

        query: myQueries.location_query,

         error(error){

           if(this.locationError == '')

            componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessFintessTabs', 'apollo', 'location', error);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
              
            this.locationError = JSON.stringify(error);
          },
      },

      facility: {

          query: myThreeQueries.facility_query,

          error(error){
                
              componentsHelpers.sendError(this.$apollo, this.userId,'MyPages-BusinessFintessTabs', 'Apollo', 'facility', error);

              componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
              
              this.facilityError = JSON.stringify(error);
            },
        },

        businessFitness: {

            query: customerQueries.slot_business_fitness_query,

            variables: function(){

                return{

                    businessId: this.myBusinessId
                }
            },

            update(data){
                
                this.sessionsLength = data.slot.length;

                this.pitchesLength = data.two_pitch_slot.length;

                this.gymMembershipsLength = data.three_gym_membership.length;
                this.studioMembershipsLength = data.three_studio_membership.length;
                this.maMembershipsLength = data.three_ma_membership.length;
                this.classMembershipsLength = data.three_class_membership.length;
                
                // console.log(`results: ${JSON.stringify(data)}`);
            },
            
            error(error){
            
            }
        }
    },

    data: function(){

        return{
            
            tokenId: 0,
            
            openedTab: 0,
            membershipsOpenedTab: 0,
            
            tabOneName: 'Sessions',

            tabTwoName: 'Pitches',

            tabThreeName: 'Memberships',

            user: null,

            userId: 0,

            businessFitness: null,

            sessionsLength: 0,

            pitchesLength: 0,
            
            gymMembershipsLength: 0,

            studioMembershipsLength: 0,

            maMembershipsLength: 0,

            classMembershipsLength: 0,
            
            category:[],
            county:[],
            location:[],
            facility:[],

            categoryMutationError: '',
            countiesError: '',
            locationError:'',
            facilityError:''
        }   
    },

}
</script>

<style>

</style>